import classNames from 'classnames';
import React, { useContext } from 'react';
import { SubPanelContainer } from '@/components/sub-panel-container';
import { useLocaleStore } from '@/i18n';
import { TextPanelContext } from '../../context';
import {
    BackgroundInspector,
    FillInspector,
    GlowInspector,
    ShadowInspector,
    StrokeInspector,
    TextEffectEntry,
} from '../../widgets';
import './style.less';

type Props = {
    type: string | null;
    free?: boolean;
    hidePresets?: boolean;
    onExit: () => void;
};

const INSPECTORS = [
    { type: 'stroke', Component: StrokeInspector },
    { type: 'shadow', Component: ShadowInspector },
    { type: 'glow', Component: GlowInspector },
    { type: 'background', Component: BackgroundInspector },
] as const;

export const TextEffectPanel: React.FC<Props> = ({ type, free = false, hidePresets = false, onExit }) => {
    const { $t } = useLocaleStore();

    const { isIntl } = useContext(TextPanelContext)!;

    const shouldShowInspector = (inspectorType: string) => {
        return type === inspectorType || !type;
    };

    return (
        <SubPanelContainer title={$t((v) => v.panel.textPanel.textEffect)} onExit={onExit}>
            {!type && (
                <TextEffectEntry
                    free={free}
                    hidePresets={hidePresets}
                    showDetailBtn={false}
                    style={{ padding: '0 16px' }}
                />
            )}
            <div
                className={classNames('text-effect-panel', { 'text-effect-panel--intl': isIntl })}
                style={{ marginTop: type ? -16 : 0 }}
            >
                <div className="text-effect-panel__inspector">
                    {!type && (
                        <>
                            <FillInspector />
                            <div className="text-effect-panel__divider" />
                        </>
                    )}

                    {INSPECTORS.map(
                        ({ type: inspectorType, Component }, index) =>
                            shouldShowInspector(inspectorType) && (
                                <React.Fragment key={inspectorType}>
                                    <Component />
                                    {index < INSPECTORS.length - 1 && <div className="text-effect-panel__divider" />}
                                </React.Fragment>
                            ),
                    )}
                </div>
            </div>
        </SubPanelContainer>
    );
};
